import React, { Component } from 'react';
import PropTypes from 'prop-types';

import FormGenerator from 'Components/Form/FormGenerator';

import InputWithCheckbox from '../InputWithCheckbox';

const MODE = {
  EDIT: 'EDIT',
  CREATE: 'CREATE',
  BOTH: 'BOTH',
};

const getFields = (isEdit, { enableCreditPrice = false, creditPrice }) => {
  const fields = [
    {
      inputType: FormGenerator.INPUT_TYPE.CUSTOM_TYPE,
      inputLabel: 'Credit Pricing',
      inputName: 'creditPrice',
      customInput: Object.assign(
        (props) => (
          <InputWithCheckbox
            initChecked={enableCreditPrice}
            type="number"
            checkBoxLabel="Enable Purchase By Credit"
            initValue={creditPrice}
            {...props}
          />
        ),
        {
          displayName: 'EnableCreditInput',
        }
      ),
      mode: MODE.BOTH,
    },
  ];

  return fields.filter(
    (f) =>
      f.mode === MODE.BOTH ||
      (isEdit && f.mode === MODE.EDIT) ||
      (!isEdit && f.mode === MODE.CREATE)
  );
};

class OnlineCourseCreditPricingForm extends Component {
  static propTypes = {
    onComplete: PropTypes.func,
    onCancelled: PropTypes.func,
    isEdit: PropTypes.bool,
  };

  handleSubmit = () => {};

  validate = ({ creditPrice }, isChanged) => {
    const error = {};
    if (isChanged && (isNaN(Number(creditPrice)) || creditPrice < 0)) {
      error.creditPrice = 'creditPrice value must not be negative';
    }
    return error;
  };

  render() {
    const { isEdit, onSubmit, initialData = {} } = this.props;
    return (
      <FormGenerator
        fields={getFields(isEdit, initialData)}
        onSubmit={onSubmit}
        customValidation={this.validate}
        submitText={isEdit ? 'Update' : 'Add'}
        cancelText="Cancel"
        showCancel
        {...this.props}
      />
    );
  }
}

export default OnlineCourseCreditPricingForm;
